import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

/**
 * LoadingSpinner component for showing loading state
 * @param {Object} props - Component props
 * @param {string} props.message - Loading message to display
 */
const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <Fade in={true}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <CircularProgress size={48} thickness={4} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

export default LoadingSpinner;
